import { z } from "zod";
import { horizonSeverityDtoSchema } from "./common.schema";
export const farmWithHorizonIssuesDtoSchema = z.object({
    customerName: z.string(),
    customerNumber: z.string(),
    farmLicenseKey: z.string().nullable(),
    lelyCenterName: z.string().nullable(),
    serviceArea: z.string(),
    orderingScore: z.number().nonnegative(),
    outdatedHorizonVersionSeverity: horizonSeverityDtoSchema.optional(),
    horizonServicesNotRunningSeverity: horizonSeverityDtoSchema.optional(),
    dbccCheckFailureSeverity: horizonSeverityDtoSchema.optional(),
    databaseSizeOverThresholdSeverity: horizonSeverityDtoSchema.optional(),
});
//# sourceMappingURL=farms-with-horizon-issues.schema.js.map